// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__EL6me","content":"Consent_content__24wu7","footer":"Consent_footer__1CXG-"};